webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(52);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(49);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: 'body',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(44)
	__vue_script__ = __webpack_require__(14)
	__vue_template__ = __webpack_require__(48)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Samples = __webpack_require__(51);
	
	var _Samples2 = _interopRequireDefault(_Samples);
	
	var _Playground = __webpack_require__(50);
	
	var _Playground2 = _interopRequireDefault(_Playground);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scrollHandler;
	
	exports.default = {
	  name: 'App',
	  components: {
	    'samples': _Samples2.default,
	    'playground': _Playground2.default
	  },
	
	  data: function data() {
	    return {
	      currentView: 'samples',
	      scrollTop: 0
	    };
	  },
	
	
	  methods: {
	    switchView: function switchView(target) {
	      this.currentView = target;
	      document.body.scrollTop = 0;
	    }
	  },
	
	  ready: function ready() {
	    var self = this;
	    scrollHandler = function scrollHandler(evt) {
	      self.scrollTop = (evt.target.scrollingElement || document.documentElement || document.body.parentNode).scrollTop || 0;
	    };
	    window.addEventListener('scroll', scrollHandler);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('scroll', scrollHandler);
	  }
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(6);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vueTimepicker = __webpack_require__(10);
	
	var _vueTimepicker2 = _interopRequireDefault(_vueTimepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scrollHandler;
	
	exports.default = {
	  name: 'Playground',
	  components: [_vueTimepicker2.default],
	  data: function data() {
	    return {
	      tokens: {
	        hour: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
	        minute: ['mm', 'm'],
	        second: ['ss', 's', 'none'],
	        apm: ['A', 'a']
	      },
	
	      type: {
	        hour: 'hh',
	        minute: 'mm',
	        second: 'ss',
	        apm: 'A'
	      },
	
	      selected: {
	        hour: 1,
	        minute: 0,
	        second: 0,
	        apm: 'am'
	      },
	
	      hourRange: {
	        min: 1,
	        max: 12
	      },
	
	      interval: {
	        minute: 1,
	        second: 1
	      },
	
	      customInterval: {
	        minute: false,
	        second: false
	      },
	
	      enableClearBtn: true,
	
	      playgroundData: {},
	
	      playgroundFullValue: {},
	
	      muteWatch: false,
	
	      scrollTop: 0
	    };
	  },
	
	
	  computed: {
	    formatString: function formatString() {
	      var formatString = this.type.hour + ':' + this.type.minute;
	      if (this.type.second !== 'none') {
	        formatString += ':' + this.type.second;
	      }
	      if (this.type.apm) {
	        formatString += ' ' + this.type.apm;
	      }
	      return formatString;
	    },
	    needApm: function needApm() {
	      return this.type.hour === 'h' || this.type.hour === 'hh';
	    },
	    htmlCode: function htmlCode() {
	      var start = '<vue-timepicker';
	      var end = '>\n</vue-timepicker>';
	
	      start += ' format="' + this.formatString + '"';
	
	      if (this.customInterval.minute) {
	        start += '\n :minute-interval="' + this.interval.minute + '"';
	      }
	
	      if (this.customInterval.second) {
	        start += '\n :second-interval="' + this.interval.second + '"';
	      }
	
	      if (!this.enableClearBtn) {
	        start += '\n hide-clear-button';
	      }
	
	      return start + end;
	    },
	    htmlCodeWithVar: function htmlCodeWithVar() {
	      var htmlCode = this.htmlCode;
	      var end = '>\n</vue-timepicker>';
	      var newEnd = '\n :time-value.sync="yourTimeValue">\n</vue-timepicker>';
	      htmlCode = htmlCode.replace(end, newEnd);
	
	      this.refreshHighlight('pghtml');
	      this.refreshHighlight('pghtmlvar');
	
	      return htmlCode;
	    },
	    yourTimeValue: function yourTimeValue() {
	      var code = 'data: function () {\n';
	      code += '  return {\n';
	      code += '    yourTimeValue: {\n';
	      code += this.listTimeValue();
	      code += '\n    }\n';
	      code += '  }\n';
	      code += '}';
	      return code;
	    }
	  },
	
	  watch: {
	    'selected': {
	      deep: true,
	      handler: 'updatePlaygroundData'
	    },
	
	    'type': {
	      deep: true,
	      handler: 'updatePlaygroundData'
	    },
	
	    needApm: function needApm(isNeeded) {
	      if (isNeeded) {
	        if (!this.selected.apm) {
	          this.type.apm = 'A';
	          this.selected.apm = 'am';
	        }
	      } else {
	        this.type.apm = '';
	        this.selected.apm = '';
	      }
	    },
	
	
	    'customInterval': {
	      deep: true,
	      handler: function handler(custom) {
	        if (!custom.minute) {
	          this.interval.minute = 1;
	        }
	        if (!custom.second) {
	          this.interval.second = 1;
	        }
	      }
	    }
	  },
	
	  methods: {
	    updateHourRange: function updateHourRange(hourType) {
	      hourType = hourType || this.type.hour;
	      var hourRange = {};
	      switch (hourType) {
	        case 'h':
	        case 'hh':
	          hourRange.min = 1;
	          hourRange.max = 12;
	          break;
	        case 'H':
	        case 'HH':
	          hourRange.min = 0;
	          hourRange.max = 23;
	          break;
	        case 'k':
	        case 'kk':
	          hourRange.min = 1;
	          hourRange.max = 24;
	          break;
	      }
	      this.hourRange = hourRange;
	      this.handleOutRangeData();
	    },
	    handleOutRangeData: function handleOutRangeData() {
	      if (this.selected.hour > this.hourRange.max) {
	        this.selected.hour = this.hourRange.max;
	      } else if (this.selected.hour < this.hourRange.min) {
	        this.selected.hour = this.hourRange.min;
	      }
	    },
	    formatValue: function formatValue(type, value) {
	      switch (type) {
	        case 'H':
	        case 'h':
	        case 'k':
	        case 'm':
	        case 's':
	          return String(value);
	        case 'HH':
	        case 'hh':
	        case 'kk':
	        case 'mm':
	        case 'ss':
	          return value < 10 ? '0' + value : String(value);
	        default:
	          return '';
	      }
	    },
	    updatePlaygroundData: function updatePlaygroundData() {
	      if (this.muteWatch) {
	        return;
	      }
	      var data = {};
	      data[this.type.hour] = this.formatValue(this.type.hour, this.selected.hour);
	      data[this.type.minute] = this.formatValue(this.type.minute, this.selected.minute);
	
	      if (this.type.second !== 'none') {
	        data[this.type.second] = this.formatValue(this.type.second, this.selected.second);
	      }
	
	      if (this.type.apm) {
	        data[this.type.apm] = this.type.apm === 'A' ? this.selected.apm.toUpperCase() : this.selected.apm;
	      }
	
	      this.playgroundData = data;
	      this.refreshHighlight('pgvalue');
	      this.refreshHighlight('pgdata');
	    },
	    listTimeValue: function listTimeValue() {
	      var data = this.playgroundData;
	      var len = (0, _keys2.default)(data).length;
	      var string = '';
	      (0, _keys2.default)(data).forEach(function (k, i) {
	        string += '      ' + k + ': ' + '"' + data[k] + '"';
	        if (i < len - 1) {
	          string += '\n';
	        }
	      });
	      return string;
	    },
	    updateRangeValue: function updateRangeValue(data) {
	      this.muteWatch = true;
	      this.selected.hour = Number(data[this.type.hour]);
	      this.selected.minute = Number(data[this.type.minute]);
	      this.selected.second = Number(data[this.type.second]);
	      this.selected.apm = (data[this.type.apm] || '').toLowerCase();
	      this.refreshHighlight('pgdata');
	      this.muteWatch = false;
	    },
	    refreshHighlight: function refreshHighlight(elm) {
	      var self = this;
	      this.$nextTick(function () {
	        window.hljs.highlightBlock(self.$els[elm]);
	      });
	    },
	    asideStyle: function asideStyle() {
	      var initPaddingTop = 220;
	      var minPaddingTop = 50;
	      return { paddingTop: Math.max(initPaddingTop - this.scrollTop, minPaddingTop) + 'px' };
	    }
	  },
	
	  events: {
	    'vue-timepicker-update': function vueTimepickerUpdate(data) {
	      this.playgroundFullValue = data;
	      this.updateRangeValue(data);
	      this.refreshHighlight('pgvalue');
	    }
	  },
	
	  attached: function attached() {
	    var self = this;
	    this.$nextTick(function () {
	      self.updateHourRange();
	      self.updatePlaygroundData();
	      window.hljs.initHighlightingOnLoad();
	    });
	  },
	  ready: function ready() {
	    var self = this;
	    scrollHandler = function scrollHandler(evt) {
	      self.scrollTop = (evt.target.scrollingElement || document.documentElement || document.body.parentNode).scrollTop || 0;
	    };
	    window.addEventListener('scroll', scrollHandler);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('scroll', scrollHandler);
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueTimepicker = __webpack_require__(10);
	
	var _vueTimepicker2 = _interopRequireDefault(_vueTimepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Samples',
	  components: [_vueTimepicker2.default],
	  data: function data() {
	    return {
	      yourData: {
	        hh: '03',
	        mm: '10',
	        ss: '00',
	        a: 'am'
	      },
	      yourFormat: 'hh:mm:ss a',
	      yourDaysArray: [{ start_time: { HH: '08', mm: '00' }, end_time: { HH: '09', mm: '00' } }, { start_time: { HH: '15', mm: '00' }, end_time: { HH: '', mm: '' } }, { start_time: { HH: '', mm: '' }, end_time: { HH: '13', mm: '30' } }, { start_time: { HH: '', mm: '' }, end_time: { HH: '', mm: '' } }],
	      muteFlowListener: true,
	      latestDataFlow: undefined,
	      demoData1: { HH: '08', mm: '30' },
	      demoData2: { HH: '10', mm: '45' },
	      demoArgs: undefined
	    };
	  },
	
	  events: {
	    'vue-timepicker-update': function vueTimepickerUpdate() {
	      var self = this;
	      this.$nextTick(function () {
	        self.refreshAllHighlight();
	      });
	    }
	  },
	  methods: {
	    refreshHighlightNextTick: function refreshHighlightNextTick() {
	      var self = this;
	      this.$nextTick(function () {
	        self.refreshAllHighlight();
	      });
	    },
	    refreshAllHighlight: function refreshAllHighlight() {
	      if (!this.$el) {
	        return;
	      }
	      var codeBlocks = this.$el.querySelectorAll('pre code');
	      Array.prototype.forEach.call(codeBlocks, function (block) {
	        window.hljs.highlightBlock(block);
	      });
	    },
	    changeHandler: function changeHandler(eventData) {
	      if (this.muteFlowListener) {
	        return;
	      }
	      this.latestDataFlow = eventData;
	      this.demoArgs = undefined;
	      this.refreshHighlightNextTick();
	    },
	    otherChangeHandler: function otherChangeHandler(eventData, arg1, arg2) {
	      if (this.muteFlowListener) {
	        return;
	      }
	      this.latestDataFlow = eventData;
	      this.demoArgs = {
	        arg1: arg1,
	        arg2: arg2
	      };
	      this.refreshHighlightNextTick();
	    }
	  },
	  compiled: function compiled() {
	    this.refreshHighlightNextTick();
	    var self = this;
	    window.setTimeout(function () {
	      self.muteFlowListener = false;
	    }, 1000);
	  },
	  ready: function ready() {
	    this.$nextTick(function () {
	      window.hljs.initHighlightingOnLoad();
	    });
	  }
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(6);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONFIG = {
	  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
	  MINUTE_TOKENS: ['mm', 'm'],
	  SECOND_TOKENS: ['ss', 's'],
	  APM_TOKENS: ['A', 'a']
	};
	
	exports.default = {
	  name: 'VueTimepicker',
	
	  props: {
	    timeValue: { type: Object, twoWay: true },
	    hideClearButton: { type: Boolean },
	    format: { type: String },
	    minuteInterval: { type: Number },
	    secondInterval: { type: Number },
	    id: { type: String }
	  },
	
	  data: function data() {
	    return {
	      hours: [],
	      minutes: [],
	      seconds: [],
	      apms: [],
	      showDropdown: false,
	      muteWatch: false,
	      hourType: 'HH',
	      minuteType: 'mm',
	      secondType: '',
	      apmType: '',
	      hour: '',
	      minute: '',
	      second: '',
	      apm: '',
	      fullValues: undefined
	    };
	  },
	
	
	  computed: {
	    displayTime: function displayTime() {
	      var formatString = String(this.format || 'HH:mm');
	      if (this.hour) {
	        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
	      }
	      if (this.minute) {
	        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
	      }
	      if (this.second && this.secondType) {
	        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
	      }
	      if (this.apm && this.apmType) {
	        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
	      }
	      return formatString;
	    },
	    showClearBtn: function showClearBtn() {
	      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
	        return true;
	      }
	      return false;
	    }
	  },
	
	  watch: {
	    'format': 'renderFormat',
	    minuteInterval: function minuteInterval(newInteval) {
	      this.renderList('minute', newInteval);
	    },
	    secondInterval: function secondInterval(newInteval) {
	      this.renderList('second', newInteval);
	    },
	
	    'timeValue': 'readValues',
	    'displayTime': 'fillValues'
	  },
	
	  methods: {
	    formatValue: function formatValue(type, i) {
	      switch (type) {
	        case 'H':
	        case 'm':
	        case 's':
	          return String(i);
	        case 'HH':
	        case 'mm':
	        case 'ss':
	          return i < 10 ? '0' + i : String(i);
	        case 'h':
	        case 'k':
	          return String(i + 1);
	        case 'hh':
	        case 'kk':
	          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
	        default:
	          return '';
	      }
	    },
	    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
	      if (!validValues || !formatString || !formatString.length) {
	        return '';
	      }
	      for (var i = 0; i < validValues.length; i++) {
	        if (formatString.indexOf(validValues[i]) > -1) {
	          return validValues[i];
	        }
	      }
	      return fallbackValue || '';
	    },
	    renderFormat: function renderFormat(newFormat) {
	      newFormat = newFormat || this.format;
	      if (!newFormat || !newFormat.length) {
	        newFormat = 'HH:mm';
	      }
	
	      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
	      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
	      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
	      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);
	
	      this.renderHoursList();
	      this.renderList('minute');
	
	      if (this.secondType) {
	        this.renderList('second');
	      }
	
	      if (this.apmType) {
	        this.renderApmList();
	      }
	
	      var self = this;
	      this.$nextTick(function () {
	        self.readValues();
	      });
	    },
	    renderHoursList: function renderHoursList() {
	      var hoursCount = this.hourType === 'h' || this.hourType === 'hh' ? 12 : 24;
	      this.hours = [];
	      for (var i = 0; i < hoursCount; i++) {
	        this.hours.push(this.formatValue(this.hourType, i));
	      }
	    },
	    renderList: function renderList(listType, interval) {
	      if (listType === 'second') {
	        interval = interval || this.secondInterval;
	      } else if (listType === 'minute') {
	        interval = interval || this.minuteInterval;
	      } else {
	        return;
	      }
	
	      if (interval === 0) {
	        interval = 60;
	      } else if (interval > 60) {
	        window.console.warn('`' + listType + '-interval` should be less than 60. Current value is', interval);
	        interval = 1;
	      } else if (interval < 1) {
	        window.console.warn('`' + listType + '-interval` should be NO less than 1. Current value is', interval);
	        interval = 1;
	      } else if (!interval) {
	        interval = 1;
	      }
	
	      if (listType === 'minute') {
	        this.minutes = [];
	      } else {
	        this.seconds = [];
	      }
	
	      for (var i = 0; i < 60; i += interval) {
	        if (listType === 'minute') {
	          this.minutes.push(this.formatValue(this.minuteType, i));
	        } else {
	          this.seconds.push(this.formatValue(this.secondType, i));
	        }
	      }
	    },
	    renderApmList: function renderApmList() {
	      this.apms = [];
	      if (!this.apmType) {
	        return;
	      }
	      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
	    },
	    readValues: function readValues() {
	      if (!this.timeValue || this.muteWatch) {
	        return;
	      }
	
	      var timeValue = JSON.parse((0, _stringify2.default)(this.timeValue || {}));
	      var values = (0, _keys2.default)(timeValue);
	      if (values.length === 0) {
	        return;
	      }
	
	      if (values.indexOf(this.hourType) > -1) {
	        this.hour = timeValue[this.hourType];
	      }
	
	      if (values.indexOf(this.minuteType) > -1) {
	        this.minute = timeValue[this.minuteType];
	      }
	
	      if (values.indexOf(this.secondType) > -1) {
	        this.second = timeValue[this.secondType];
	      } else {
	        this.second = 0;
	      }
	
	      if (values.indexOf(this.apmType) > -1) {
	        this.apm = timeValue[this.apmType];
	      }
	
	      this.fillValues();
	    },
	    fillValues: function fillValues() {
	      var fullValues = {};
	
	      var baseHour = this.hour;
	      var baseHourType = this.hourType;
	
	      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
	      var baseOnTwelveHours = this.isTwelveHours(baseHourType);
	      var apmValue = baseOnTwelveHours && this.apm ? String(this.apm).toLowerCase() : false;
	
	      CONFIG.HOUR_TOKENS.forEach(function (token) {
	        if (token === baseHourType) {
	          fullValues[token] = baseHour;
	          return;
	        }
	
	        var value = void 0;
	        var apm = void 0;
	        switch (token) {
	          case 'H':
	          case 'HH':
	            if (!String(hourValue).length) {
	              fullValues[token] = '';
	              return;
	            } else if (baseOnTwelveHours) {
	              if (apmValue === 'pm') {
	                value = hourValue < 12 ? hourValue + 12 : hourValue;
	              } else {
	                value = hourValue % 12;
	              }
	            } else {
	              value = hourValue % 24;
	            }
	            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
	            break;
	          case 'k':
	          case 'kk':
	            if (!String(hourValue).length) {
	              fullValues[token] = '';
	              return;
	            } else if (baseOnTwelveHours) {
	              if (apmValue === 'pm') {
	                value = hourValue < 12 ? hourValue + 12 : hourValue;
	              } else {
	                value = hourValue === 12 ? 24 : hourValue;
	              }
	            } else {
	              value = hourValue === 0 ? 24 : hourValue;
	            }
	            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
	            break;
	          case 'h':
	          case 'hh':
	            if (apmValue) {
	              value = hourValue;
	              apm = apmValue || 'am';
	            } else {
	              if (!String(hourValue).length) {
	                fullValues[token] = '';
	                fullValues.a = '';
	                fullValues.A = '';
	                return;
	              } else if (hourValue > 11) {
	                apm = 'pm';
	                value = hourValue === 12 ? 12 : hourValue % 12;
	              } else {
	                if (baseOnTwelveHours) {
	                  apm = '';
	                } else {
	                  apm = 'am';
	                }
	                value = hourValue % 12 === 0 ? 12 : hourValue;
	              }
	            }
	            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
	            fullValues.a = apm;
	            fullValues.A = apm.toUpperCase();
	            break;
	        }
	      });
	
	      if (this.minute || this.minute === 0) {
	        var minuteValue = Number(this.minute);
	        fullValues.m = String(minuteValue);
	        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
	      } else {
	        fullValues.m = '';
	        fullValues.mm = '';
	      }
	
	      if (this.second || this.second === 0) {
	        var secondValue = Number(this.second);
	        fullValues.s = String(secondValue);
	        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
	      } else {
	        fullValues.s = '';
	        fullValues.ss = '';
	      }
	
	      this.fullValues = fullValues;
	      this.updateTimeValue(fullValues);
	      this.$dispatch('vue-timepicker-update', fullValues);
	    },
	    updateTimeValue: function updateTimeValue(fullValues) {
	      if (!this.timeValue) {
	        this.$dispatch('change', { data: fullValues });
	        return;
	      }
	
	      this.muteWatch = true;
	
	      var baseTimeValue = JSON.parse((0, _stringify2.default)(this.timeValue || {}));
	      var timeValue = {};
	      (0, _keys2.default)(baseTimeValue).forEach(function (key) {
	        timeValue[key] = fullValues[key];
	      });
	      this.timeValue = timeValue;
	
	      var self = this;
	      this.$nextTick(function () {
	        self.muteWatch = false;
	        self.$dispatch('change', { data: self.timeValue });
	      });
	    },
	    isTwelveHours: function isTwelveHours(token) {
	      return token === 'h' || token === 'hh';
	    },
	    toggleDropdown: function toggleDropdown() {
	      this.showDropdown = !this.showDropdown;
	    },
	    select: function select(type, value) {
	      if (type === 'hour') {
	        this.hour = value;
	      } else if (type === 'minute') {
	        this.minute = value;
	      } else if (type === 'second') {
	        this.second = value;
	      } else if (type === 'apm') {
	        this.apm = value;
	      }
	    },
	    clearTime: function clearTime() {
	      this.hour = '';
	      this.minute = '';
	      this.second = '';
	      this.apm = '';
	    }
	  },
	
	  ready: function ready() {
	    this.renderFormat();
	  }
	};

/***/ },
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 44 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 45 */
/***/ function(module, exports) {

	module.exports = " <div class=main-wrapper> <header v-cloak> <h1>Vue Timepicker</h1> <p>A dropdown time picker for <span class=version>Vue 1.x</span> with flexible time format support</p> </header> <nav class=top-nav :class=\"{stick: scrollTop > 150}\"> <span class=title>Vue Timepicker</span> <ul> <li><a @click=\"switchView('samples')\" :class=\"{active: currentView === 'samples'}\">Common Usage</a></li> <li><a @click=\"switchView('playground')\" :class=\"{active: currentView === 'playground'}\">Playground</a></li> <li><a href=https://github.com/phoenixwong/vue-timepicker target=_blank>Documentation</a></li> </ul> <span class=v2x><a href=https://phoenixwong.github.io/vue2-timepicker/ target=_blank>Vue 2.x Version</a> &raquo;</span> </nav> <main class=content :class=\"{'nav-affixed': scrollTop > 150}\"> <component :is=currentView transition=fade transition-mode=out-in> <div slot=footer-links> <h3 class=title><a class=anchor id=more>#</a>More complex usage</h3> <div class=description> <p>Didn't find what you need? Please check the <a @click=\"switchView('playground')\">Playground</a> or <a href=https://github.com/phoenixwong/vue-timepicker target=_blank>Documentation</a> for more inspiration.</p> </div> </div> </component> </main> </div> ";

/***/ },
/* 46 */
/***/ function(module, exports) {

	module.exports = " <section id=playground> <main> <h2 class=section-title>Timepicker Playground</h2> <div id=configPanel> <div class=config-block id=typesSelection> <h3 class=subtitle><a class=anchor>#</a>Generate <code>format</code> string</h3> <div class=config-row> <label class=row-label>Hour:</label> <label class=options v-for=\"htype in tokens.hour\" :for=\"'hour_type' + $index\"> <input v-model=type.hour @click=updateHourRange(htype) :value=htype :id=\"'hour_type' + $index\" type=radio name=hour_type /> {{htype}} </label> </div> <div class=config-row> <label class=row-label>Minute:</label> <label class=options v-for=\"mtype in tokens.minute\" :for=\"'minute_type' + $index\"> <input v-model=type.minute :value=mtype :id=\"'minute_type' + $index\" type=radio name=minute_type /> {{mtype}} </label> </div> <div class=config-row> <label class=row-label>Second:</label> <label class=options v-for=\"stype in tokens.second\" :for=\"'second_type' + $index\"> <input v-model=type.second :value=stype :id=\"'second_type' + $index\" type=radio name=second_type /> {{stype}} </label> </div> <div class=config-row v-if=needApm> <label class=row-label>AM/PM:</label> <label class=options v-for=\"atype in tokens.apm\" :for=\"'apm_type' + $index\"> <input v-model=type.apm :value=atype :id=\"'apm_type' + $index\" type=radio name=apm_type /> {{atype}} </label> </div> </div> <div class=config-block> <h3 class=subtitle><a class=anchor>#</a>Customized Interval</h3> <div class=\"config-row group\"> <label> <input v-model=customInterval.minute type=checkbox /> Minute Interval </label> <label v-if=customInterval.minute class=range-wrapper> <input v-model=interval.minute type=range min=0 max=60 step=1 /> <span v-text=interval.minute></span> </label> </div> <div class=\"config-row group\"> <label> <input v-model=customInterval.second type=checkbox /> Second Interval </label> <label v-if=customInterval.second class=range-wrapper> <input v-model=interval.second type=range min=0 max=60 step=1 /> <span v-text=interval.second></span> </label> </div> </div> <div class=config-block> <h3 class=subtitle><a class=anchor>#</a>Clear Button</h3> <div class=\"config-row group\"> <label for=enable_btn_true> <input v-model=enableClearBtn type=radio id=enable_btn_true name=enable_btn :value=true /> Enable </label> <label for=enable_btn_false> <input v-model=enableClearBtn type=radio id=enable_btn_false name=enable_btn :value=false /> Disable </label> </div> </div> <div class=codes> <pre data-title=HTML><code v-el:pghtml class=html v-text=htmlCode></code></pre> </div> <div class=config-block id=valuesSelection> <h3 class=subtitle><a class=anchor>#</a>Bind <code>time-value</code> data</h3> <div class=config-row> <label class=row-label>Hour:</label> <label class=options> <input v-model=selected.hour type=range :min=hourRange.min :max=hourRange.max step=1 /> <span v-text=selected.hour></span> </label> </div> <div class=config-row> <label class=row-label>Minute:</label> <label class=options> <input v-model=selected.minute type=range min=0 max=59 :step=interval.minute /> <span v-text=selected.minute></span> </label> </div> <div v-if=\"type.second !== 'none'\" class=config-row> <label class=row-label>Second:</label> <label class=options> <input v-model=selected.second type=range min=0 max=59 :step=interval.second /> <span v-text=selected.second></span> </label> </div> <div v-if=needApm :class=\"{capitailized: type.apm === 'A'}\" class=config-row> <label class=row-label>AM/PM:</label> <label class=options for=selected_apm_am> <input v-model=selected.apm type=radio id=selected_apm_am name=selected_apm value=am /> am </label> <label class=options for=selected_apm_pm> <input v-model=selected.apm type=radio id=selected_apm_pm name=selected_apm value=pm /> pm </label> </div> </div> <div class=codes> <pre data-title=JS><code v-el:pgdata class=javascript v-text=yourTimeValue></code></pre> </div> <div class=codes> <pre data-title=HTML><code v-el:pghtmlvar class=html v-text=htmlCodeWithVar></code></pre> </div> </div> </main> <aside class=previews :style=asideStyle()> <div id=playgroundPreview class=preview> <b>Format string: </b> <span v-text=formatString></span> <p> <vue-timepicker :format=formatString :time-value.sync=playgroundData :minute-interval=interval.minute :second-interval=interval.second :hide-clear-button=!enableClearBtn></vue-timepicker> </p> </div> <div id=dispatchedValue class=codes> <pre data-title=vue-timepicker-update><code v-el:pgvalue class=json v-text=\"playgroundFullValue | json 2\"></code></pre> </div> </aside> </section> ";

/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports = " <section id=mostlyUsedSamples> <h2 class=section-title>Common Usage</h2> <div class=block> <h3 class=title><a class=anchor id=default>#</a>Default</h3> <div class=description> <p>Default to 24-hour format <code>HH:mm</code></p> </div> <div class=codes> <pre data-title=HTML><code v-el:ugdefault class=html>&lt;vue-timepicker&gt;&lt;/vue-timepicker&gt;</code></pre> </div> <div class=preview> <vue-timepicker></vue-timepicker> </div> </div> <div class=block> <h3 class=title><a class=anchor id=format12hours>#</a>12 Hours</h3> <div class=description> <p>By properly define the <code>format</code> string, you can set timepicker in form of 12 hours</p> </div> <div> <div class=codes> <pre data-title=HTML>\n<code class=html>&lt;!-- 12-hour sample 1 --&gt;\n&lt;vue-timepicker format=\"hh:mm A\"&gt;&lt;/vue-timepicker&gt;\n\n&lt;!-- 12-hour sample 2 --&gt;\n&lt;vue-timepicker format=\"h:m a\"&gt;&lt;/vue-timepicker&gt;\n</code>\n</pre> </div> <div class=preview> <b>12-hour sample 1</b> <p> <vue-timepicker format=\"hh:mm A\"></vue-timepicker> </p> <b>12-hour sample 2</b> <p> <vue-timepicker format=\"h:m a\"></vue-timepicker> </p> </div> </div> </div> <div class=block> <h3 class=title><a class=anchor id=seconds>#</a>Seconds Picker</h3> <div class=description> <p>You can trigger the seconds picker by adding <code>ss</code> or <code>s</code> in your format string.</p> </div> <div class=codes> <pre data-title=HTML><code class=html>&lt;vue-timepicker format=\"HH:mm:ss\"&gt;&lt;/vue-timepicker&gt;</code></pre> </div> <div class=preview> <vue-timepicker format=HH:mm:ss></vue-timepicker> </div> </div> <div class=block> <h3 class=title><a class=anchor id=interval>#</a>Customized Interval</h3> <div class=description> <p>Timepicker also allows you to display minutes or seconds picker with certain interval, like a 10-minute interval <code>0, 10, 20, ... 50, 60</code> for example</p> </div> <div class=codes> <pre data-title=HTML>\n<code class=html>&lt;!-- 10-minute interval --&gt;\n&lt;vue-timepicker :minute-interval=\"10\"&gt;&lt;/vue-timepicker&gt;\n\n&lt;!-- 15-second interval --&gt;\n&lt;vue-timepicker format=\"HH:mm:ss\" :second-interval=\"15\"&gt;&lt;/vue-timepicker&gt;\n\n&lt;!-- 5-minute interval plus 10-second interval --&gt;\n&lt;vue-timepicker format=\"hh:mm:ss\" :minute-interval=\"5\" :second-interval=\"10\"&gt;&lt;/vue-timepicker&gt;\n</code>\n</pre> </div> <div class=preview> <b>10-minute interval</b> <p> <vue-timepicker :minute-interval=10></vue-timepicker> </p> <b>15-second interval</b> <p> <vue-timepicker format=HH:mm:ss :second-interval=15></vue-timepicker> </p> <b>5-minute interval plus 10-second interval</b> <p> <vue-timepicker format=hh:mm:ss :minute-interval=5 :second-interval=10></vue-timepicker> </p> </div> </div> <div class=block> <h3 class=title><a class=anchor id=sync>#</a>Sync Data</h3> <div class=description> <p>Manipulate your timepicker's data as usual</p> </div> <div class=codes> <pre data-title=JS><code class=javascript>data: {\n  yourFormat: 'hh:mm:ss a',\n  yourData: {\n    hh: '03',\n    mm: '10',\n    ss: '00',\n    a: 'am'\n  }\n}</code></pre> </div> <div class=codes> <pre data-title=HTML><code class=html>&lt;vue-timepicker :format=\"yourFormat\" :time-value.sync=\"yourData\"&gt;&lt;/vue-timepicker&gt;</code></pre> </div> <div> <div class=preview> <vue-timepicker :format=yourFormat :time-value.sync=yourData></vue-timepicker> </div> </div> </div> <div class=block> <h3 class=title><a class=anchor id=hideClearButton>#</a>Hide Clear Button</h3> <div class=description> <p>If you don't want to expose the clear button in the UI, <code>hide-clear-button</code> property will do the trick.</p> </div> <div class=codes> <pre data-title=HTML><code class=html>&lt;vue-timepicker hide-clear-button&gt;&lt;/vue-timepicker&gt;</code></pre> </div> <div class=preview> <vue-timepicker hide-clear-button></vue-timepicker> </div> </div> <div class=block> <h3 class=title><a class=anchor id=vForSample>#</a>Work with <code>v-for</code></h3> <div class=description> <p>Here's a quick sample of <code>v-for</code> usage</p> </div> <div class=codes> <pre data-title=JS><code class=javascript>data: {\n  yourDaysArray: [\n    {start_time: {HH: '08', mm: '00'}, end_time: {HH: '09', mm: '00'}},\n    {start_time: {HH: '15', mm: '00'}, end_time: {HH: '', mm: ''}},\n    {start_time: {HH: '', mm: ''}, end_time: {HH: '13', mm: '30'}},\n    {start_time: {HH: '', mm: ''}, end_time: {HH: '', mm: ''}}\n  ]\n}</code></pre> </div> <div class=codes> <pre data-title=HTML><code class=html>\n&lt;p v-for=\"day in yourDaysArray\"&gt;\n  &lt;label&gt;Day <span>{{</span> $index + 1 <span>}}</span>: &lt;/label&gt;\n  &lt;vue-timepicker :time-value.sync=\"day.start_time\"&gt;&lt;/vue-timepicker&gt;\n  &lt;span&gt; to &lt;/span&gt;\n  &lt;vue-timepicker :time-value.sync=\"day.end_time\"&gt;&lt;/vue-timepicker&gt;\n&lt;/p&gt;\n</code></pre> </div> <div class=preview> <p v-for=\"day in yourDaysArray\"> <label>Day {{ $index + 1 }}: </label> <vue-timepicker :time-value.sync=day.start_time></vue-timepicker> <span> to </span> <vue-timepicker :time-value.sync=day.end_time></vue-timepicker> </p> </div> <div class=codes> <pre data-title=\"yourDaysArray JSON\"><code class=json v-text=\"yourDaysArray | json 2\">\n</code></pre> </div> </div> <div class=block> <h3 class=title><a class=anchor id=onChangeSample>#</a>The <code>change</code> Event</h3> <div class=description> <p>The <code>change</code> event was introduced in v0.2.1. You can use <code>@change</code> to target and handle individual return data.</p> </div> <div class=codes> <pre data-title=JS><code class=javascript>\nmethods: {\n  // No argument\n  changeHandler (eventData) {\n    // eventData -> {data: {HH:..., mm:...}}\n  },\n\n  // Customized arguments\n  otherChangeHandler (eventData, arg1, arg2) {\n    // eventData -> [{data: {HH:..., mm:...}}]\n    // arg1 -> 'foo' or 'bar' in this demo\n    // arg2 -> 1 or 42 in this demo\n  }\n}\n</code></pre> </div> <div class=codes> <pre data-title=HTML><code class=html>&lt;!--\n[A] With `time-value` set\n--&gt;\n\n&lt;!-- A-1: No argument --&gt;\n&lt;vue-timepicker :time-value.sync=\"demoData1\" @change=\"changeHandler\"&gt;&lt;/vue-timepicker&gt;\n\n&lt;!-- A-2: Custom argument --&gt;\n&lt;vue-timepicker :time-value.sync=\"demoData2\" @change=\"otherChangeHandler($arguments, 'foo', 1)\"&gt;&lt;/vue-timepicker&gt;\n\n&lt;!--\n[B] No binding `time-value`\n--&gt;\n\n&lt;!-- B-1: No argument --&gt;\n&lt;vue-timepicker @change=\"changeHandler\"&gt;&lt;/vue-timepicker&gt;\n\n&lt;!-- B-2: Custom argument --&gt;\n&lt;vue-timepicker @change=\"otherChangeHandler($arguments, 'bar', 42)\"&gt;&lt;/vue-timepicker&gt;\n</code></pre> </div> <div class=preview> <p> <b>[A] With `time-value` set, <code>change</code> event will only returns values in predefined format</b> </p> <b>A-1: No argument</b> <p> <vue-timepicker :time-value.sync=demoData1 @change=changeHandler></vue-timepicker> </p> <b>A-2: Custom argument ('foo', 1)</b> <p> <vue-timepicker :time-value.sync=demoData2 @change=\"otherChangeHandler($arguments, 'foo', 1)\"></vue-timepicker> </p> <p> <b>[B] No binding `time-value`, full value data will be returned</b> </p> <b>B-1: No argument</b> <p> <vue-timepicker @change=changeHandler></vue-timepicker> </p> <b>B-2: Custom argument ('bar', 42)</b> <p> <vue-timepicker @change=\"otherChangeHandler($arguments, 'bar', 42)\"></vue-timepicker> </p> </div> <div class=codes v-if=demoArgs> <pre data-title=\"Custom Arguments\"><code class=javascript v-text=\"demoArgs | json\">\n</code></pre> </div> <div class=codes v-if=latestDataFlow> <pre data-title=\"Latest eventData\"><code class=javascript v-text=\"latestDataFlow | json\">\n</code></pre> </div> </div> <div class=\"block footer-links\"> <slot name=footer-links></slot> </div> </section> ";

/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports = " <span class=time-picker> <input class=display-time v-model=displayTime :id=id @click.stop=toggleDropdown type=text readonly=readonly /> <span class=clear-btn v-if=!hideClearButton v-show=\"!showDropdown && showClearBtn\" @click.stop=clearTime>&times;</span> <div class=time-picker-overlay v-if=showDropdown @click.stop=toggleDropdown></div> <div class=dropdown v-show=showDropdown> <div class=select-list> <ul class=hours> <li class=hint v-text=hourType></li> <li v-for=\"hr in hours\" v-text=hr :class=\"{active: hour === hr}\" @click.stop=\"select('hour', hr)\"></li> </ul> <ul class=minutes> <li class=hint v-text=minuteType></li> <li v-for=\"m in minutes\" v-text=m :class=\"{active: minute === m}\" @click.stop=\"select('minute', m)\"></li> </ul> <ul class=seconds v-if=secondType> <li class=hint v-text=secondType></li> <li v-for=\"s in seconds\" v-text=s :class=\"{active: second === s}\" @click.stop=\"select('second', s)\"></li> </ul> <ul class=apms v-if=apmType> <li class=hint v-text=apmType></li> <li v-for=\"a in apms\" v-text=a :class=\"{active: apm === a}\" @click.stop=\"select('apm', a)\"></li> </ul> </div> </div> </span> ";

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(43)
	__vue_script__ = __webpack_require__(11)
	__vue_template__ = __webpack_require__(45)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(12)
	__vue_template__ = __webpack_require__(46)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(13)
	__vue_template__ = __webpack_require__(47)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.7b86c713d192e7d8fe9e.js
 **/